import React from 'react'

const colClassMap: Record<string, string> = {
    '1': 'grid-cols-1',
    '2': 'grid-cols-2',
    '3': 'grid-cols-3',
    '4': 'grid-cols-4',
}

export default function SectionBlock({cols,className, children}:{cols?:string,className?:string; children: React.ReactNode}) {
    const colClass = cols ? colClassMap[cols] ?? '' : ''
  return (
    <section className={`w-full grid ${colClass} items-center justify-center relative py-10 pb-20 ${className}`}>
      {children}
    </section>
  )
}
